import { Wrap } from './styles';

import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';

/**
 * ItemList
 * 
 * @param {*} label
 * @param {string} type
 * @param {string} name
 * @param {number} index
 * @param {boolean} onChange
 * @param {number} value
 * @param {*} props
 * 
 * @returns 
 */
const ItemList = ({
  checked,
  label,
  type,
  name,
  index,
  onChange,
  value,
  ...props
}) => {
  return (
    <Wrap>
      <label htmlFor={`${name}-${index}`}>{label}</label>
      {type === 'checkbox' ? (
        <Checkbox
          id={`${name}-${index}`}
          checked={checked}
          onChange={onChange}
          value={value}
          size="small"
        />
      ) : (
        <Radio
          id={`${name}-${index}`}
          checked={checked}
          onChange={onChange}
          value={value}
          size="small"
        />
      )}
    </Wrap>
  );
};

export default ItemList;
